import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddBillingAccountComponent } from './add-billing-account.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { MspPopupModule } from '../msp-popup/msp-popup.module';

@NgModule({
  declarations: [AddBillingAccountComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ModalModule.forRoot(),
    MspPopupModule,
  ],
  exports: [AddBillingAccountComponent],
})
export class AddBillingAccountModule {}
